import { useQuery } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import getAllCustomSIPHeaders from 'API/CustomSIPHeaders/getAllCustomSIPHeaders';

const useGetAllCustomSIPHeaders = (setTableData) => {
    const { currentPartner } = useSelector((state) => state.navigationLists);
    const { currentScope } = useSelector((state) => state.login);
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ['customSIPHeaders', currentPartner, currentScope],
        queryFn: async () => {
            try {
                const data = await getAllCustomSIPHeaders(currentScope).then(
                    (res) => {
                        const sortedData = res.sort((a, b) => {
                            const nameA = a.name?.toLowerCase() || '';
                            const nameB = b.name?.toLowerCase() || '';
                            if (nameA < nameB) return -1;
                            if (nameA > nameB) return 1;
                            return 0;
                        });

                        setTableData((prev) => ({
                            ...prev,
                            data: sortedData,
                        }));

                        dispatch({
                            type: 'CHANGE_TABLE_LOADING',
                        });

                        return sortedData;
                    },
                );
                return data;
            } catch (error) {
                console.error('Error fetching custom SIP headers:', error);
                throw error;
            }
        },
        refetchOnWindowFocus: false,
        staleTime: 0,
    });
};

export default useGetAllCustomSIPHeaders;
